(function ($) {
    // Check if jQuery and CookieConsent exist
    if (typeof $ === 'undefined' || typeof CookieConsent === 'undefined') {
		console.log('jQuery or CookieConsent is not defined');
        return;
    }

    $(document).on('click', "[data-custom-target='cookie-popup']", function(e) {
        e.preventDefault();
        CookieConsent.renew();
		return false;
    });
})(jQuery);
